<template>
  <router-view />
  <GlobalQuickMenu />
</template>

<script setup lang="ts">
  import GlobalQuickMenu from '@/components/GlobalQuickMenu.vue';
</script>

<style lang="less">
  html {
    -webkit-text-size-adjust: 100%;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  /* 使用全局快速菜单，屏蔽历史页面内置的重复菜单入口 */
  .nav-menu-btn,
  .nav-menu {
    display: none !important;
  }

  @media (max-width: 768px) {
    .verify-screen :is(input, textarea, select, .ant-input, .ant-select-selection-search-input) {
      font-size: 16px !important;
    }
  }
</style>
